import {
  LocalStorageKey,
  LocalStorageService,
} from '../../shared/storage/local-storage';

export function isAppInstallPromptCompleted(): boolean {
  return (
    LocalStorageService.getValue(LocalStorageKey.appInstallPromptCompleted) ===
    true
  );
}

export function setAppInstallPromptCompleted(value: boolean): void {
  LocalStorageService.setValue(
    LocalStorageKey.appInstallPromptCompleted,
    value,
  );
}
